import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_MARK_INSTALLATION_AS_COMPLETED,
} from 'api/actionTypes';

export default async function markInstallationAsCompleted(
  { state, apiClient },
  { marketingListingId, installationMarkedAsCompleted, markedInstallMissingItems }
) {
  typeCheck('marketingListingId::PositiveNumber', marketingListingId);
  typeCheck('installationMarkedAsCompleted::Boolean', installationMarkedAsCompleted);

  return apiClient.postWithState({
    action: SR_API_ACTION_MARK_INSTALLATION_AS_COMPLETED,
    state: state,
    payload: {
      marketingListingId,
      installationMarkedAsCompleted,
      markedInstallMissingItems,
    },
  });
}
